import { useEffect, useRef } from "react";

const SCRIPT_ID = "cloudflare-turnstile-script";
const SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

const loadTurnstile = () =>
  new Promise((resolve, reject) => {
    if (window.turnstile) {
      resolve(window.turnstile);
      return;
    }

    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.turnstile), { once: true });
      existing.addEventListener("error", reject, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.addEventListener("load", () => resolve(window.turnstile), { once: true });
    script.addEventListener("error", reject, { once: true });
    document.head.appendChild(script);
  });

const TurnstileWidget = ({ siteKey, onToken, resetKey }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let active = true;
    let widgetId = null;

    if (!siteKey || !containerRef.current) return undefined;

    loadTurnstile()
      .then((turnstile) => {
        if (!active || !containerRef.current || !turnstile) return;
        widgetId = turnstile.render(containerRef.current, {
          sitekey: siteKey,
          action: "open_order_quote",
          callback: (token) => onToken(token),
          "expired-callback": () => onToken(""),
          "error-callback": () => onToken(""),
          theme: "light",
        });
      })
      .catch(() => onToken(""));

    return () => {
      active = false;
      if (widgetId !== null && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    };
  }, [onToken, resetKey, siteKey]);

  return <div ref={containerRef} />;
};

export default TurnstileWidget;
